import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import LoginForm from 'components/login_form/LoginForm'
import ContactMethodFieldsForm from 'components/login_form/ContactMethodFieldsForm'
import LoginConfirmationForm from 'components/LoginConfirmationForm'

import {
  backToLoginFormPage,
  requestSubmitLogin,
  setUseMaskedEmail,
  showContactMethodFieldsForm,
  submitConfirmation,
  updateLoginForm,
  wrongPhoneNumber
} from 'src/actions/login'

import { contactMethodSelector, hostSelector, invitationSelector } from 'src/selectors'

import { fullName } from 'src/services/user_helpers'

import { CONTACT_METHOD, EMAIL_CONTACT_METHOD, PHONE_NUMBER_CONTACT_METHOD } from 'src/services/contact_methods'

import styles from './require-user-on-guest-list.scss'

class RequireUserOnGuestList extends React.Component {
  _requestSubmitLogin = () => {
    const { dispatch, loginForm } = this.props
    const username = this._oauthUsername()
    let contactMethodType = this._contactMethodType()
    if (contactMethodType === EMAIL_CONTACT_METHOD && loginForm.useMaskedEmail) {
      contactMethodType = CONTACT_METHOD
    }
    dispatch(requestSubmitLogin(username, contactMethodType))
  };

  _requestContactMethod = () => {
    const { dispatch } = this.props
    dispatch(showContactMethodFieldsForm())
  }

  _submitConfirmation = (confirmationCode) => {
    const { dispatch, loginForm } = this.props
    const { firstName, lastName } = loginForm
    const username = this._oauthUsername()
    let contactMethodType = this._contactMethodType()
    if (contactMethodType === EMAIL_CONTACT_METHOD && loginForm.useMaskedEmail) {
      contactMethodType = CONTACT_METHOD
    }
    dispatch(submitConfirmation({ firstName, lastName, username, confirmationCode, contactMethodType }))
  };

  _contactMethodType () {
    const { contactMethod } = this.props
    if (contactMethod) {
      return contactMethod.type
    } else {
      return PHONE_NUMBER_CONTACT_METHOD
    }
  }

  _oauthUsername () {
    const { invitation, loginForm } = this.props
    switch (this._contactMethodType()) {
      case EMAIL_CONTACT_METHOD:
        if (loginForm.useMaskedEmail) {
          return invitation.contact_method.hash
        } else {
          return loginForm.emailAddress
        }
      case PHONE_NUMBER_CONTACT_METHOD:
        return loginForm.phoneNumber
      default:
        return loginForm.phoneNumber
    }
  }

  _formatMessage (message) {
    const {
      user,
      host
    } = this.props

    if (user) {
      message = message.replace('{user_first_name}', user.first_name)
    }
    if (host) {
      message = message.replace('{host_name}', fullName(host))
    }
    return message
  }

  _renderConfirmationCodeForm () {
    const {
      contactMethod,
      loginForm,
      loginFormClassName,
      dispatch,
      transparent
    } = this.props
    const backToContactMethodFieldsFormPage = () => dispatch(wrongPhoneNumber())
    const updateForm = (params) => dispatch(updateLoginForm(params))

    return (
      <div className={loginFormClassName}>
        <LoginConfirmationForm
          contactMethod={contactMethod}
          loginForm={loginForm}
          onSubmitConfirmation={this._submitConfirmation}
          backToContactMethodFieldsFormPage={backToContactMethodFieldsFormPage}
          onResendCode={this._requestSubmitLogin}
          updateForm={updateForm}
          transparent={transparent}
        />
      </div>
    )
  }

  _renderContactMethodFieldsForm () {
    const {
      dispatch,
      contactMethod,
      loginForm,
      loginMessage,
      transparent,
      isMenu
    } = this.props
    const updateForm = (params) => dispatch(updateLoginForm(params))
    let setUseMaskedEmailFalse = () => dispatch(setUseMaskedEmail(false))
    const backToLoginForm = () => dispatch(backToLoginFormPage())

    let message = loginMessage || loginForm.loginMessage || ''
    message = this._formatMessage(message)
    return (
      <ContactMethodFieldsForm
        contactMethod={contactMethod}
        setUseMaskedEmailFalse={setUseMaskedEmailFalse}
        message={message}
        fields={loginForm}
        updateForm={updateForm}
        submitForm={this._requestSubmitLogin}
        transparent={transparent}
        isMenu={isMenu}
        backToLoginFormPage={backToLoginForm}
      />
    )
  }

  _renderLoginForm () {
    const {
      dispatch,
      contactMethod,
      loginForm,
      loginFormClassName,
      loginMessage,
      transparent
    } = this.props
    const updateForm = (params) => dispatch(updateLoginForm(params))
    let setUseMaskedEmailFalse = () => dispatch(setUseMaskedEmail(false))

    let message = loginMessage || loginForm.loginMessage || ''
    message = this._formatMessage(message)

    return (
      <div className={loginFormClassName}>
        <LoginForm
          contactMethod={contactMethod}
          setUseMaskedEmailFalse={setUseMaskedEmailFalse}
          message={message}
          fields={loginForm}
          dispatch={dispatch}
          updateForm={updateForm}
          submitForm={this._requestContactMethod}
          transparent={transparent}
        />
      </div>
    )
  }

  _renderComponent () {
    const { user, children, loginForm } = this.props

    if (!user) {
      if (loginForm.showContactMethodFieldsForm) {
        return this._renderContactMethodFieldsForm()
      }
      if (loginForm.showConfirmationCodeForm) {
        return this._renderConfirmationCodeForm()
      }

      return this._renderLoginForm()
    } else {
      if (children) {
        return <div>
          {children}
        </div>
      } else {
        return null
      }
    }
  }

  _getTitleAndSubTitle () {
    const { user, loginForm } = this.props
    if (!user) {
      if (loginForm.showContactMethodFieldsForm) {
        const title = loginForm.loginModalTitle
        const subTitle = loginForm.loginModalSubtitle
        return {
          title: title,
          subTitle: subTitle
        }
      }

      if (loginForm.showConfirmationCodeForm) {
        return {
          title: 'Confirm Number',
          subTitle: ''
        }
      }
      const firstPageSubtitle = loginForm.loginModalFirstPageSubtitle
      return {
        title: 'Name',
        subTitle: firstPageSubtitle
      }
    } else {
      return {
        title: '',
        subTitle: ''
      }
    }
  }

  componentDidUpdate () {
    const { user, onSubscribeSuccessActions, dispatch } = this.props
    if (user && onSubscribeSuccessActions) {
      onSubscribeSuccessActions.forEach(action => {
        dispatch(action)
      })
    }
  }

  render () {
    let { title = '', subTitle = '' } = this._getTitleAndSubTitle()
    return (
      <div>
        <h3 className={styles['title']}>{title}</h3>
        <div className={styles['sub-title']}>{subTitle}</div>
        {this._renderComponent()}
      </div>
    )
  }
}

RequireUserOnGuestList.propTypes = {
  dispatch: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ]),
  contactMethod: PropTypes.object,
  user: PropTypes.object,
  loginForm: PropTypes.object,
  invitation: PropTypes.object,
  loginMessage: PropTypes.string,
  host: PropTypes.object,
  transparent: PropTypes.bool,
  loginFormClassName: PropTypes.string,
  onSubscribeSuccessActions: PropTypes.array,
  isMenu: PropTypes.bool
}

function mapStateToProps (state) {
  const { loginForm, userId, entities } = state
  const host = hostSelector(state)
  const contactMethod = contactMethodSelector(state)
  const invitation = invitationSelector(state)

  return {
    contactMethod,
    invitation,
    loginForm,
    user: entities.users[userId],
    host
  }
}

export default connect(mapStateToProps)(RequireUserOnGuestList)



// WEBPACK FOOTER //
// ./src/containers/RequireUserOnGuestList.jsx